import React, { useEffect } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { PainSection } from '../components/sales/PainSection';
import { TwistSection } from '../components/sales/TwistSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { CTASection } from '../components/sales/CTASection';
import { Footer } from '../components/sales/Footer';
import { initMetaPixel } from '../lib/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-[#FDFBF7]" data-id="element-155">
      <HeroSection data-id="element-156" />
      <LeadSection data-id="element-157" />
      <PainSection data-id="element-158" />
      <TwistSection data-id="element-159" />
      <BenefitsSection data-id="element-160" />
      <CTASection data-id="element-161" />
      <Footer data-id="element-162" />
    </main>;
}